import { isDev } from "../../../base/index.js";
function throwError() {
  if (isDev()) {
    throw new Error(`You cannot use a FormState Context without mounting a FormRoot component as an ancestor.`);
  }
}
function safeNoop() {
  throwError();
}
function safeNoopBool() {
  throwError();
  return false;
}
function createEmptyFormState() {
  return {
    api: {
      setDebugMode: safeNoop,
      getDebugMode: () => "silent",
      clearError: safeNoop,
      getErrors: () => {
        throwError();
        return {};
      },
      getField: () => {
        throwError();
        return { type: "field", value: "", status: "pristine", resetValue: "" };
      },
      getFields: () => {
        throwError();
        return {};
      },
      getFieldValues: () => {
        throwError();
        return {};
      },
      getFormId: () => {
        throwError();
        return "";
      },
      registerField: () => {
        throwError();
        return false;
      },
      deregisterField: () => {
        throwError();
      },
      getFieldErrors: () => {
        throwError();
        return [];
      },
      getMeta: () => {
        throwError();
        return {
          disabled: false,
          submitting: false,
          validating: false,
          status: "pristine"
        };
      },
      getValues: () => {
        throwError();
        return {};
      },
      getInitialValues: () => {
        throwError();
        return {};
      },
      initialize: safeNoop,
      reset: safeNoop,
      change: safeNoop,
      batch: safeNoop,
      setFieldVisibleState: safeNoop,
      setFieldDisabledState: safeNoop,
      setFieldRequiredState: safeNoop,
      addFormMutation: safeNoop,
      removeFormMutation: safeNoopBool,
      addFieldMutation: safeNoop,
      removeFieldMutation: safeNoopBool,
      removeAllFormMutations: safeNoop,
      removeAllFieldMutations: safeNoop,
      addFieldTransform: safeNoop,
      removeFieldTransform: safeNoopBool,
      removeAllFieldTransforms: safeNoop,
      waitForValidation: () => {
        throwError();
        return Promise.resolve();
      },
      setDisabled: safeNoop,
      setSubmitting: safeNoop,
      clearValidation: safeNoop,
      validate: () => {
        throwError();
        return Promise.resolve(false);
      },
      addValidation: safeNoop,
      getValidator: safeNoop,
      removeValidation: safeNoopBool,
      removeAllValidations: safeNoop,
      subscribeToForm: () => safeNoop,
      subscribeToMeta: () => safeNoop,
      subscribeToField: () => safeNoop,
      removeAllListeners: safeNoop,
      // -----------------------------------------------------------------
      // ARRAY API
      // -----------------------------------------------------------------
      changeArrayElement: safeNoop,
      removeArrayElements: safeNoop,
      addArrayElements: safeNoop,
      swapArrayElements: safeNoop,
      clearArrayElements: safeNoop
    },
    store: {
      id: "_____defaultEmptyState_____",
      initialValues: {},
      values: {},
      errors: {},
      fields: {},
      meta: {
        disabled: false,
        submitting: false,
        validating: false,
        status: "pristine"
      }
    }
  };
}
export {
  createEmptyFormState
};
//# sourceMappingURL=createEmptyFormState.js.map
